import axios from 'axios'
import notification from 'ant-design-vue/es/notification'
import { Modal } from 'ant-design-vue'
import { VueAxios } from './axios'
import cookie from 'js-cookie'

// 创建AI专用的axios实例
const aiAxiosInstance = axios.create()

// 异常拦截处理器
const errorHandler = (error) => {
  if (error.response) {
    const data = error.response.data
    if (data.code === 'not_found') {
      notification.error({
        message: 'Forbidden',
        description: '该数据已被删除'
      })
    } else {
      notification.error({
        message: 'Forbidden',
        description: data.message
      })
    }
  }
}

// 为AI实例配置请求拦截器
aiAxiosInstance.interceptors.request.use(config => {
  config.headers = Object.assign({
    'Content-Type': 'application/json',
    'X-Auth': localStorage.getItem('token'),
    'Authorization': 'Bearer app-EKpdcW05JYuiACeY3d8GrtSq'
  }, config.headers)
  return config
}, errorHandler)

// 为AI实例配置响应拦截器
aiAxiosInstance.interceptors.response.use((response) => {
  console.log(response)
  const data = response.data
  if (data.code !== 200 && data.code !== 20000) {
    // 处理非成功状态码
  }
  return response.data
}, errorHandler)

export const aiAppRequest = async (data) => {
  return new Promise((resolve, reject) => {
    const config = {
      withCredentials: true, // 是否跨站点访问控制请求
      ...data
      // timeout: 6000 // 请求超时间
    }
    // 固定添加 userid 参数
    // 获取用户ID
    const userId = 9
    // 根据请求方法类型添加用户ID
    if (config.method?.toLowerCase() === 'get') {
      config.params = {
        ...(config.params || {}),
        user: userId
      }
    } else {
      config.data = config.data instanceof FormData
        ? (config.data.append('user', userId), config.data)
        : {
            ...(config.data || {}),
            user: userId
          }
    }
    const pams = aiAxiosInstance(config)
    if (pams) {
      resolve(pams)
    } else {
      reject(pams)
    }
  }).catch(err => {
    const { status } = err.response
    Modal.error({ title: `服务器出现了问题，请稍后再试，code：${status}！！！` })
  })
}

const installer = {
  vm: {},
  install(Vue) {
    Vue.use(VueAxios, aiAppRequest)
  }
}
// export default request
export {
  installer as VueAxios,
  aiAppRequest as axios
}
